import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const ErrorContainer = styled(Flexbox)`
  background: #ff1f3a;
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(8)}px;
`;
